'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UnstyledButton from '../UnstyledButton';
import getPDFPageState from '../../selectors/getPDFPageState';
import { MAIN_CONTENT_ANCHOR } from '../../lib/constants';
const ZOOM_RATIO = 11 / 10;
export default class PDFControls extends PureComponent {
  constructor(...args) {
    super(...args);

    this.previousPage = () => {
      document.getElementById(MAIN_CONTENT_ANCHOR).focus();
      this.props.onPage(this.props.pageIndex - 1);
    };

    this.nextPage = () => {
      document.getElementById(MAIN_CONTENT_ANCHOR).focus();
      this.props.onPage(this.props.pageIndex + 1);
    };

    this.zoomOut = () => {
      this.props.onZoom(this.props.zoom / ZOOM_RATIO);
    };

    this.zoomIn = () => {
      this.props.onZoom(this.props.zoom * ZOOM_RATIO);
    };
  }

  render() {
    const {
      visible,
      totalPages
    } = this.props;
    const {
      pageNumber,
      previousPageDisabled,
      nextPageDisabled
    } = getPDFPageState(this.props);
    return /*#__PURE__*/_jsxs("div", {
      tabIndex: 0,
      className: "pdf-controls",
      "aria-label": I18n.text('a11y.hiddenPDFControls'),
      style: {
        opacity: visible ? 1 : 0
      },
      children: [/*#__PURE__*/_jsx("span", {
        className: "m-x-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pdf.controls.page",
          options: {
            pageNumber,
            totalPages
          }
        })
      }), /*#__PURE__*/_jsxs("span", {
        className: "m-x-3",
        children: [/*#__PURE__*/_jsx(UnstyledButton, {
          "aria-label": I18n.text('a11y.previousPage'),
          "aria-disabled": previousPageDisabled,
          className: "m-right-2",
          disabled: previousPageDisabled,
          onClick: this.previousPage,
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "left",
            className: 'control-icon' + (previousPageDisabled ? " control-icon-disabled" : "")
          })
        }), /*#__PURE__*/_jsx(UnstyledButton, {
          className: "m-right-2",
          "aria-label": I18n.text('a11y.nextPage'),
          "aria-disabled": nextPageDisabled,
          disabled: nextPageDisabled,
          onClick: this.nextPage,
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "right",
            className: 'control-icon' + (nextPageDisabled ? " control-icon-disabled" : "")
          })
        })]
      }), /*#__PURE__*/_jsxs("span", {
        "aria-hidden": true,
        className: "m-x-3",
        children: [/*#__PURE__*/_jsx(UnstyledButton, {
          id: "zoom",
          onClick: this.zoomOut,
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "zoomOut",
            className: "control-icon m-right-4"
          })
        }), /*#__PURE__*/_jsx(UnstyledButton, {
          onClick: this.zoomIn,
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "zoomIn",
            className: "control-icon"
          })
        })]
      })]
    });
  }

}
PDFControls.propTypes = {
  visible: PropTypes.bool,
  pageIndex: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
  onPage: PropTypes.func.isRequired,
  onZoom: PropTypes.func.isRequired
};
PDFControls.defaultProps = {
  visible: true
};